module.exports = __webpack_public_path__ + "img/ESTEE-01.610b382f.png";